import React, { useCallback, useState } from 'react';
import { Button, Space, message, Breadcrumb, Table, Spin } from 'antd';
import { CardLayout, TableWrapper, LecturerEditModal, FileViewerModal } from 'components/molecules';
import { addNewSearch } from 'utils/utils';
import { useLocation, useNavigate } from 'react-router';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import qs from 'query-string';
import { TotalNumMenu } from 'components/atoms';
import { useTableInfo, useLecturer } from 'hooks';
import { INIT_PAGESIZE } from 'commons/constants';
import LecturerSearchBox from './SearchBox'
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import moment from 'moment';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { isFileViewer } from 'utils/file-utils';
import { fetcher } from 'services';
import * as XLSX from 'xlsx';

export interface  LecturerProps {}

const  Lecturer = ({}:  LecturerProps): React.ReactElement => {
 /* ======================================================
   * hooks
   * ====================================================== */
 const navigate = useNavigate();
 const location = useLocation();
 const { refetch, lecturerList, searchResult, lecturerFileUpdate } = useLecturer();  

 /* ======================================================
  * variables
  * ====================================================== */
 const { open } = usePopupManager();
 const [isLoding, setIsLoading] = useState<boolean>(false);   

 const searchParams = qs.parse(location.search);
 const columns: ColumnsType<LecturerListDto> = [
   {
     title: '번호',
     dataIndex: 'id',
     key: 'id',
     width: '70px',
     align: 'center',
   },  
   {
     title: '강사명',
     dataIndex: 'name',
     key: 'name',
     width: '120px',
     align: 'center',     
   },  
   {
     title: '구분',
     dataIndex: 'lecturer_type',
     key: 'lecturer_type',
     width: '120px',
     align: 'center',
     render: (lecturer_type, record) => {
      return (
        lecturer_type === 'IN'?'내부강사':'외부강사'
      )
     }       
   },
   {
    title: '핸드폰',
    dataIndex: 'phone',
    key: 'phone',
    width: '120px',
    align: 'center',
    ellipsis: true,
  },   
   {
     title: '이메일',
     dataIndex: 'email',
     key: 'email',
     width: '200px',
     align: 'left',
     ellipsis: true,
   },
   {
    title: '통장',
    dataIndex: 'account_number_file_id',
    key: 'account_number_file_id',
    width: '80px',
    align: 'center',
    render: (account_number_file_id, record) => {
      return (      
        <Space>
          {(account_number_file_id > 0) && (
            <>
              <Button shape="round" onClick={(e) => {e.stopPropagation(); onDownload(account_number_file_id, record.account_number_file_name);}} icon={<DownloadOutlined />} size='small' style={{padding:'3px'}}/>
              {isFileViewer(record.account_number_file_name) && (<Button shape="round" onClick={(e) => {e.stopPropagation(); onOpenFileViewer(account_number_file_id, record.account_number_file_name, record.id, 'account', true);}} icon={<SearchOutlined />} size='small' style={{padding:'3px'}}/>)}            
            </>
          )}        
        </Space>  
      )
    }      
  },
  {
    title: '발행서류',
    dataIndex: 'identity_number_file_id',
    key: 'identity_number_file_id',
    width: '80px',
    align: 'center',
    render: (identity_number_file_id, record) => {
      return (      
        <Space>
          {(identity_number_file_id > 0) && (
            <>
              <Button shape="round" onClick={(e) => {e.stopPropagation(); onDownload(identity_number_file_id, record.identity_number_file_name);}} icon={<DownloadOutlined />} size='small' style={{padding:'3px'}}/>
              {isFileViewer(record.identity_number_file_name) && (<Button shape="round" onClick={(e) => {e.stopPropagation(); onOpenFileViewer(identity_number_file_id, record.identity_number_file_name, record.id, 'identity', true);}} icon={<SearchOutlined />} size='small' style={{padding:'3px'}}/>)}            
            </>
          )}        
        </Space>  
      )
    }      
  },
  {
    title: '프로필',
    dataIndex: 'profile_file_id',
    key: 'profile_file_id',
    width: '80px',
    align: 'center',
    render: (profile_file_id, record) => {
      return (      
        <Space>
          {(profile_file_id > 0) && (
            <>
              <Button shape="round" onClick={(e) => {e.stopPropagation(); onDownload(profile_file_id, record.profile_file_name);}} icon={<DownloadOutlined />} size='small' style={{padding:'3px'}}/>
              {isFileViewer(record.profile_file_name) && (<Button shape="round" onClick={(e) => {e.stopPropagation(); onOpenFileViewer(profile_file_id, record.profile_file_name, record.id, 'profile', true);}} icon={<SearchOutlined />} size='small' style={{padding:'3px'}}/>)}            
            </>
          )}        
        </Space>  
      )
    }      
  },  
  {
    title: '단가',
    dataIndex: 'price',
    key: 'price',
    width: '80px',
    align: 'right',
    render: (price, record) => {
      return (
        price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      )
     }  
  },  
  {
    title: '소득형태',
    dataIndex: 'income_type',
    key: 'income_type',
    width: '120px',
    align: 'center',
  },    
  {
    title: '메모',
    dataIndex: 'memo',
    key: 'memo',
    width: 'auto',
    align: 'left',
    ellipsis: true,
  },  
  {
    title: '히스토리',
    key: 'history',
    width: '80px',
    align: 'center',
    render: (loginYn, record) => {
      return (
        <Button
          type='default'
          onClick={(e) => {
            e.stopPropagation();
          }}
        >보기</Button>
      )
    }    
  }, 
 ];

 /* ======================================================
  * events
  * ====================================================== */    
 const onClickRegister = () => {
  open(LecturerEditModal, {
    id: 0,
    onClose: (isOk) => {
      if (isOk) {
        refetch();     
      };
    },
  }); 
 }

 const onOpenFileViewer = (fileId: number, fileName: string, seq: number, gubun: string, editable: boolean) => {
  open(FileViewerModal, {
    fileid: fileId,
    filename: fileName,
    seq: seq,
    gubun: gubun,
    editable: editable,
    onClose: (isOk, seq, gubun, files) => {
      if (isOk) {
        if (gubun === 'account') {
          lecturerFileUpdate({
            id: seq,
            account_fileData: files,
          }) 
        } else if (gubun === 'identity') {
          lecturerFileUpdate({
            id: seq,
            identity_fileData: files,
          }) 
        } else if (gubun === 'profile') {
          lecturerFileUpdate({
            id: seq,
            profile_fileData: files,
          }) 
        }
      };
    },
  });   
 }

 const onChangePageInfo = (pageNo: number, pageSize: number) => {
   navigate({
     ...location,
     search: addNewSearch(location.search, { pageNo, pageSize }),
   });
 };  

 const onRowClick = useCallback((record, index) => {
   return {
     onClick: () => {
      open(LecturerEditModal, {
        id: Number(record.id),
        onDownload,
        onFilePreview: onOpenFileViewer,
        onClose: (isOk) => {
          if (isOk) {
            refetch(); 
          }
        },
      }); 
     },
   };
 }, []);


 const onExcelDownload = () => {
  setIsLoading(true); 
  fetcher.lecturer.postLecturerList({
    pageNo: 1,
    pageSize: 0,
    searchValue: searchParams.search ? String(searchParams.search) : '',        
    lecturer_type: searchParams.lecturer_type ? String(searchParams.lecturer_type) : '',
    lecturer_category: searchParams.lecturer_category ? String(searchParams.lecturer_category) : '',  
  })
  .then((res) => {
      switch (res.code) {
          case 200:
          if (!!res.result) {
            const book = XLSX.utils.book_new();
            const nurses = XLSX.utils.json_to_sheet(
              res.result.list.map((item, index) => {
                return {
                  '번호' : item.id,
                  '강사명' : item.name,
                  '구분': item.lecturer_type === 'IN'?'내부강사':'외부강사',
                  '핸드폰번호': item.phone,
                  '이메일': item.email,
                  '단가': item.price,
                  '소득형태': item.income_type,
                  '메모': item.memo,
                }
              }), 
              { 
                header : [
                  '번호',
                  '강사명',
                  '구분',
                  '핸드폰번호',
                  '이메일',
                  '단가',
                  '소득형태',
                  '메모',
                ], 
                skipHeader : false 
              } 
            );
        
            nurses["!cols"] = [
              { wpx : 60 } 
            , { wpx : 100 } 
            , { wpx : 100 }  
            , { wpx : 120 }  
            , { wpx : 150 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 300 } 
            ]
        
            XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
        
            XLSX.writeFile( book, "강사목록.xlsx" ); 
          }
          break;
          default:  
          break;
      };
      setIsLoading(false);         
  });   
 }  

 const onDownload = (fileSeq:number, fileName: string): void => {
  axios({
    url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
    method: 'get',
    responseType: 'blob',
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    })
    .catch(() => {
      message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
    });
  };
  /* ======================================================
   * hooks
   * ====================================================== */
  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: Number(searchParams.pageNo) || 1,
      pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
    },
    datas: lecturerList,
    totalCount: searchResult.totalCount,
    onChangePageInfo,
  });

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>강사목록</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <LecturerSearchBox />
          <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
            <TotalNumMenu totalNum={searchResult.totalCount} useRegister useExcelDownload onUseRegister={onClickRegister} onDownloadExcel={onExcelDownload}/>
            <TableWrapper isSearch={!!searchParams.search || !!searchParams.lecturer_type || !!searchParams.lecturer_category}>
              <Table
                tableLayout="fixed"
                dataSource={lecturerList}
                columns={columns}
                pagination={pagination}
                onChange={onTableChange}
                onRow={onRowClick}
                style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                className="columnCenterFixTable clickable"
                showSorterTooltip={false}
                rowKey={'id'}
              />
            </TableWrapper>  
          </Spin>
        </Space>                
    </CardLayout>
  )
};

export default  Lecturer;    